// CMMI maturity level definitions: source of truth for level labels,
// percentage ranges, and brand colors. Used by the scorer and every UI
// component that renders a maturity badge, bar, chart, or label.

export const MATURITY_LEVELS = [
  { level: 1, label: 'Initial',    range: '0–19',   minScore: 0,  color: '#C04A3D' },
  { level: 2, label: 'Developing', range: '20–39',  minScore: 20, color: '#C28A2A' },
  { level: 3, label: 'Defined',    range: '40–59',  minScore: 40, color: '#B89030' },
  { level: 4, label: 'Managed',    range: '60–79',  minScore: 60, color: '#2D7A4A' },
  { level: 5, label: 'Optimizing', range: '80–100', minScore: 80, color: '#1F5F2F' }
]

// Map a 0-100 percentage score to a maturity level. Boundaries use >=,
// so a score of exactly 40 maps to Defined, 60 to Managed, 80 to Optimizing.
export function getMaturityLevelByScore(percentage) {
  for (let i = MATURITY_LEVELS.length - 1; i >= 0; i--) {
    if (percentage >= MATURITY_LEVELS[i].minScore) return MATURITY_LEVELS[i]
  }
  return MATURITY_LEVELS[0]
}
